import api from './api';

export const getAssessmentCriteria = async () => {
  const response = await api.get('/assessment/criteria');
  return response.data;
};

export const getAssessmentByHousingId = async (housingDataId) => {
  const response = await api.get(`/assessment/${housingDataId}`);
  return response.data;
};

export const createAssessment = async (housingDataId, assessmentData) => {
  const response = await api.post(`/assessment/${housingDataId}`, assessmentData);
  return response.data;
};

export const getAssessmentScore = async (housingDataId) => {
  const response = await api.get(`/assessment/${housingDataId}/score`);
  return response.data;
}; 